import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Avatar from "@material-ui/core/Avatar";
import Typography from "@material-ui/core/Typography";
import { useSpring, animated } from "react-spring";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    padding: theme.spacing(4),
  },
  avatar: {
    width: theme.spacing(16),
    height: theme.spacing(16),
    borderRadius: "50%",
    margin: "auto",
  },
  title: {
    fontWeight: "bold",
    marginBottom: theme.spacing(2),
    color: "#54b3d6",
  },
  description: {
    lineHeight: 1.5,
  },
}));

function About() {
  const classes = useStyles();

  const avatarProps = useSpring({
    to: { transform: "scale(1)" },
    from: { transform: "scale(0)" },
    config: { duration: 1000 },
  });

  const titleProps = useSpring({
    to: { opacity: 1 },
    from: { opacity: 0 },
    config: { duration: 1000 },
  });

  const descriptionProps = useSpring({
    to: { opacity: 1 },
    from: { opacity: 0 },
    config: { duration: 1000 },
    delay: 500,
  });

  return (
    <div className={classes.root}>
      <Grid container spacing={4}>
        <Grid item xs={12} md={4}>
          <animated.div style={avatarProps}>
            <Avatar
              alt="AlfaRojo"
              src="https://github.com/AlfaRojo.png"
              className={classes.avatar}
            />
          </animated.div>
        </Grid>
        <Grid item xs={12} md={8}>
          <animated.div style={titleProps}>
            <Typography variant="h4" className={classes.title}>
              El cookie
            </Typography>
          </animated.div>
          <animated.div style={descriptionProps}>
          <Typography variant="body1" className={classes.description}>
            Yo soy Kevin, estudiante de ingenieria de software y amante del coleccionismo del TCG. Creé esta página para poder mandar a gradear tarjetas, principalmente de Pokemon, pero el TCG contiene muchas áreas, así que sientete libre de elegir la tarjeta que sea de tu agrado para mandarla a gradear. Si tienes problemas con la página o algún error persistente, ponte en contacto con migo al correo <a mailto="kevin.tec.mat@hotmail.com">kevin.tec.mat@hotmail.com</a>
          </Typography>
          </animated.div>
        </Grid>
      </Grid>
    </div>
  );
}

export default About;
